import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function initFooterReveal() {
    if (!prefersReducedMotion) {
        const $footer = $('.site-footer'),
            $footerInner = $('.site-footer__inner');

        // prepare footer for reveal animation
        gsap.set($footerInner, {yPercent: -33.33});

        const reveal = gsap.timeline({paused: true});

        reveal.to($footerInner, {
            yPercent: 0,
            ease: 'none'
        });

        ScrollTrigger.create({
            trigger: $footer,
            start: 'top bottom',
            end: 'top top',
            animation: reveal,
            scrub: true,
        });
    }
}

$('body').on('initScripts pageTransitionComplete', function() {
    initFooterReveal();
});
